<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import type { OrderPrices } from "@core/schema/OrderPrices.js";
	import { deliveryFreeThreshold } from "@core/schema/deliveryFreeThreshold.js";
	import { formatPrice } from "@core/utils/formatPrice.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

	const { prices, class: customClass }: { prices: OrderPrices; class?: ClassValue } = $props();
	const { tenant } = getGlobalTemplateProps();
	const priceWithoutDelivery = $derived(prices.totalPrice.withTax - prices.deliveryPrice);
</script>

<div class={[customClass, "flex flex-col gap-3 rounded-lg grow text-center md:text-left"]}>
	{#if deliveryFreeThreshold - priceWithoutDelivery < 0}
		<span class="text-nov-dark-800 text-2sm">
			Máte od nás <span class="text-nov-dark-900 font-bold">DOPRAVU ZDARMA</span>
		</span>
	{:else}
		<span class="text-nov-dark-800 text-2sm">
			Do <span class="text-nov-dark-900 font-bold">DOPRAVY ZDARMA</span> zbývá nakoupit ještě za
			<span class="text-nov-dark-900 font-bold">
				{formatPrice(deliveryFreeThreshold - priceWithoutDelivery, tenant.locale, false)}
			</span>
		</span>
	{/if}
	<div class="h-3 w-full max-w-114 lg:min-w-92 rounded-lg bg-nov-light-200 mx-auto md:mx-0">
		<div
			class="h-full rounded-lg bg-nov-green-100 relative"
			style:width={`${Math.min(100, (priceWithoutDelivery / deliveryFreeThreshold) * 100)}%`}
		></div>
	</div>
</div>
